<template>
    <div class="revenue-detail">
        <iframe :src="pageUrl" class="iframe1" id="iframe1"></iframe>

    </div>
</template>

<script>
    export default {
        name: 'MonthBill',
        data() {
            return {
                pageUrl: '',
                currentId: 1
            }   
        },
        methods: {
            queryUrl(params) {
                this.axios(
                    {
                        method:'get',
                        url:'/api/externalInterface/queryPageUrl', 
                        params: {
                            pageNum: params,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.pageUrl = response.data.data.pageUrl
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            getUrlParams(params) {
                this.queryUrl(params)
                this.$forceUpdate()
                this.currentId = params
            }
        },
        mounted: function() {
            this.currentId = this.$route.query.key
            this.queryUrl(this.currentId)
            window.addEventListener('message', (e) => {
                if(e.data.path == 'searchCustomer/company-search'){
                    this.$emit('famethod','1')
                }else if(e.data.path == 'searchCustomer/industry-template'){
                    this.$emit('famethod','2')
                }else if(e.data.path == 'searchCustomer/advanced-search'){
                    this.$emit('famethod','3')
                }else if(e.data.path == 'searchCustomer/map-search'){
                    this.$emit('famethod','4')
                }else if(e.data.path == 'searchCustomer/batch-check-company'){
                    this.$emit('famethod','5')
                }
            }, false);

        }
    }
</script>

<style scoped lang="less">
    .revenue-detail{
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
        .iframe1{
            width: 100%;
            height: 100%;
            border: medium none;
        }
    }
</style>